.illustration {
    flex: 0 0 33%;
}

.illustration img,
.illustration svg {
    width: 100%;
    max-width: 100%;
    max-height: 250px;
}

.feature-card--with-illustration {
    grid-column: span 2;
    grid-row: span 2;
}

.features-container {
    min-height: 710px;
    gap: 24px;
    display: flex;
    flex-direction: column;
}
